function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLWolontariat1 = function SvgLWolontariat1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    "data-name": "Warstwa 2",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.59 150.76H70.78c-24.27 0-44.01-19.74-44.01-44.01V72.04h24.28v34.71c0 10.88 8.85 19.73 19.74 19.73h45.81v24.28Z",
    style: {
      fill: "#091f2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.77 47.74h24.28v24.3H26.77z",
    style: {
      fill: "#e41f13"
    }
  })));
};
export default SvgLWolontariat1;